export default __webpack_public_path__ + "static/media/mental-health-icon.047fae01.svg";